import { makeTextComponent } from './makeTextComponent'

export const Corpus = makeTextComponent(
  'shade-00 font-size-large font-family-system line-height-larger font-weight-regular'
)
